/* *
 * ========================================================================
 * Vortex Solution
 * ========================================================================
 * */

// Includes the custom Modernizr build based on the configurations set in .modernizrrc
require('Modernizr'); // eslint-disable-line import/no-extraneous-dependencies
require('nodelist-foreach-polyfill');
require('element-qsa-scope');
require('./main/dropdown-menu');
require('./main/mobile-menu');
require('./main/navbar');
require('./main/user-is-tabbing');
require('./main/forms');
require('./global-search');
require('./main/search-modal');
require('./main/breadcrumbs');
require('./main/accordions');
require('./main/buttons');
require('./main/video');
require('./main/alert');
require('./main/popup');
require('./main/search-page');
require('./main/member-modal');
require('./main/member-mobile-menu');
require('./main/member-area');
require('./main/partners');
require('./main/member-add-user-form');
require('./main/ads');
